import api from '@/lib/axios';

export interface TicketMessage {
  id: string;
  content: string;
  sender: {
    id: string;
    name: string;
  };
  sender_type: 'customer' | 'admin' | 'system';
  created_at: string;
}

export interface SupportTicketAPI {
  id: string;
  ticket_number: string;
  subject: string;
  description: string;
  category: string;
  priority: string;
  status: string;
  customer: {
    id: string;
    name: string;
    email: string;
    phone: string;
  };
  assigned_to?: {
    id: string;
    name: string;
  };
  booking_id?: string;
  messages: TicketMessage[];
  created_at: string;
  updated_at: string;
}

export interface TicketsQueryParams {
  page?: number;
  limit?: number;
  status?: string;
  priority?: string;
  category?: string;
  search?: string;
}

export interface TicketsPaginatedResponse {
  data: SupportTicketAPI[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface TicketStats {
  open: number;
  in_progress: number;
  resolved: number;
  closed: number;
  total: number;
}

export const supportApi = {
  getAll: async (params: TicketsQueryParams): Promise<TicketsPaginatedResponse> => {
    const response = await api.get('/support/admin/tickets', { params });
    return {
      data: response.data.data || [],
      pagination: response.data.pagination || { page: 1, limit: 20, total: 0, totalPages: 1 },
    };
  },

  getById: async (id: string): Promise<SupportTicketAPI> => {
    const response = await api.get(`/support/tickets/${id}`);
    return response.data.data;
  },

  reply: async (id: string, content: string): Promise<TicketMessage> => {
    const response = await api.post(`/support/admin/tickets/${id}/reply`, { content });
    return response.data.data;
  },

  updateStatus: async (id: string, status: string): Promise<SupportTicketAPI> => {
    const response = await api.put(`/support/admin/tickets/${id}/status`, { status });
    return response.data.data;
  },

  getStats: async (): Promise<TicketStats> => {
    const response = await api.get('/support/admin/tickets/stats');
    return response.data.data;
  },
};
